// Generated by Copilot
import { RichContentRenderer } from "@/components/helpers/ui/RichContentRenderer";
import { Box } from "@/components/layout/flexbox";
import { MeetingButton } from "@/components/pages_logged_in/program/components/program-component/panels/MeetingButton";
import { PanelProps } from "@/types/programs";

export function ProgramGroupMeetingItemPanel({
  component,
  onEdit,
  view = "list",
}: PanelProps) {
  const { participantGuidance } = component || {};
  const formFields = component?.survey?.formFields || [];
  const mainFormField = formFields?.[0] || null;

  if (view === "feed") {
    return (
      <div className="xs:p-3.5 xs:rounded-md xs:gap-3 flex flex-col bg-gradient-to-br from-[#F2FAFF] to-[#D8ECF8] md:gap-4 md:rounded-lg md:p-6">
        <div className="text-lg font-semibold text-blue-800">
          You have an upcoming meeting
        </div>
        <div>
          <MeetingButton
            url={mainFormField?.link?.url || ""}
            date={component.targetStartDate!}
            onEdit={onEdit}
          />
        </div>
      </div>
    );
  }

  return (
    <Box className="xs:gap-3.5 flex flex-col md:gap-4 empty:hidden">
      {participantGuidance ? (
        <RichContentRenderer content={participantGuidance} />
      ) : null}

      <MeetingButton
        url={mainFormField?.link?.url || ""}
        date={component.targetStartDate!}
        onEdit={onEdit}
      />
    </Box>
  );
}
